// import { digitGroup } from 'src/helpers/index'

const initForm = {
  name: null,
  email: null,
  access_type: null
}

export default function () {
  return {
    table: {
      access: {
        visibleColumns: [
          'name'
        ],
        columns: [
          {
            name: 'name',
            field: (row) => {
              return `<strong
                  class="text-primary cursor-pointer"
                  router-push="${
                    encodeURIComponent(
                      JSON.stringify({
                        name: 'admin-access-form',
                        params: {
                          action: 'preview',
                          id: row.id,
                          name: row.name
                        }
                      })
                    )
                  }"
                >${row.name}</strong>`
            },
            label: 'Akses',
            sortable: true,
            align: 'left',
            rowClass: 'text-left text-primary q-py-lg'
          }
        ]
      },

      list: {
        visibleColumns: ['name', 'access_type', 'email'],
        columns: [
          {
            name: 'name',
            field: (row) => {
              return `<a href="/admin/form/preview/${
                row.user_id
              }/${encodeURIComponent(
                row.user_name
              )}" class="goto-preview-page"><span class="text-weight-bold
              ">${row.user_name}</span></a> `
            },
            label: 'Nama',
            sortable: true,
            align: 'left',
            rowClass: 'text-left text-no-wrap'
          },
          {
            name: 'email',
            field: (row) => {
              return row.user_email || '-'
            },
            label: 'Email',
            sortable: true,
            align: 'left',
            rowClass: 'text-left'
          },
          {
            name: 'access_type',
            field: (row) => {
              return (
                `<div role="alert" class="custom-badge custom-badge-green">${row.role_name}</div>` ||
                '-'
              )
            },

            label: 'Jenis Akses',
            sortable: true,
            align: 'left',
            rowClass: 'text-left'
          },
          {
            name: 'status',
            field: (row) => {
              return row.user_status
                ? '<div role="alert" class="custom-badge custom-badge-green">Aktif</div>'
                : '<div role="alert" class="custom-badge custom-badge-red">Tidak Aktif</div>'
            },
            label: 'Status User',
            sortable: true,
            align: 'left',
            rowClass: 'text-left'
          }
        ],
        columnsDelete: [
          {
            name: 'name',
            field: (row) => {
              return `<a href="/admin/form/preview/${
                row.user_id
              }/${encodeURIComponent(
                row.user_name
              )}" class="goto-preview-page"><span class="text-weight-bold
              ">${row.user_name}</span></a> `
            },
            label: 'Nama',
            sortable: true,
            align: 'left',
            rowClass: 'text-left text-no-wrap'
          },
          {
            name: 'email',
            field: (row) => {
              return row.user_email || '-'
            },
            label: 'Email',
            sortable: true,
            align: 'left',
            rowClass: 'text-left'
          },
          {
            name: 'access_type',
            field: (row) => {
              return (
                `<div role="alert" class="custom-badge custom-badge-green">${row.role_name}</div>` ||
                '-'
              )
            },

            label: 'Jenis Akses',
            sortable: true,
            align: 'left',
            rowClass: 'text-left'
          }
        ]
      }
    },

    filterResponse: {},
    selectedRow: [],
    fetchedData: null,

    variantType: {
      value: null
    },

    formDefault: JSON.parse(JSON.stringify(initForm)),
    form: { ...initForm }
  }
}
